export class AppPlatform {
	private readonly buttonSelector = '.js-app-platform__button';
	private readonly iosButtonSelector = '.js-app-platform__ios';
	private readonly hiddenClass = 'mobile-app-button--hidden';

	private container: HTMLElement | null;
	private buttons: NodeListOf<HTMLElement> | null;
	private iosButton: HTMLElement | null;

	constructor(container: HTMLElement) {
		if (!container) return;
		this.container = container;

		this.init();
	}

	private init = (): void => {
		this.buttons = this.container.querySelectorAll<HTMLElement>(this.buttonSelector);
		this.iosButton = this.container.querySelector<HTMLElement>(this.iosButtonSelector);
		const app = window.app as {
			getDeviceType(): string;
			isIOS(): boolean;
		};

		if (app.getDeviceType() !== 'mobile') return;

		if (app.isIOS()) {
			this.showOnlyIOS();
		} else {
			this.hideIOS();
		}
	};

	public destroy = (): void => {
		this.container = null;
		this.buttons = null;
		this.iosButton = null;
	};

	private showOnlyIOS = (): void => {
		this.buttons?.forEach((button) => {
			if (button !== this.iosButton) {
				button.classList.add(this.hiddenClass);
			}
		});
	};

	private hideIOS = (): void => {
		if (this.iosButton) {
			this.iosButton?.classList.add(this.hiddenClass);
		}
	};
}
